export default __webpack_public_path__ + "static/media/girlPhone.0685d8af.png";